import { createSlice } from "@reduxjs/toolkit";

export type AccountFeatures = {
    canCreateSite: boolean;
    hideMenus: boolean;
    canDisableSite: boolean;
    canDeleteAccount: boolean;
    hideAlternativeTexts: boolean;
};

const accountFeaturesSlice = createSlice({
    name: "accountFeatures",
    initialState: {
        canCreateSite: true,
        hideMenus: false,
        canDisableSite: true,
        canDeleteAccount: true,
        hideAlternativeTexts: false,
    } as AccountFeatures,
    reducers: {
        handleAccountFeatures: (state, action) => {
            state.canCreateSite = action.payload.canCreateSite;
            state.hideMenus = action.payload.hideMenus;
            state.canDisableSite = action.payload.canDisableSite;
            state.canDeleteAccount = action.payload.canDeleteAccount;
            state.hideAlternativeTexts = action.payload.hideAlternativeTexts;
        },
    },
});

export const { handleAccountFeatures } = accountFeaturesSlice.actions;
export default accountFeaturesSlice.reducer;
